<main class="main">
  <header class="main--header">
    <img class="main--header__logo" src="../../../assets/logos/seat-cupra-logo-white.svg"
      alt="{{ 'altLogo' | i18next }}" />
  </header>
  <section class="register">
    <h2 class="title">{{ 'userCreation' | i18next }}</h2>
    <form [formGroup]="registerForm" class="form">
      <!-- CRMSP-7485 - Acceso a MyGarage VO para jubilados -->
      <mat-form-field *ngIf="isExternVoOrRetiree()">
        <mat-label>{{ 'registerType' | i18next }}</mat-label>

        <mat-select [value]="externVoRegisterType" (selectionChange)="changeExternVoRegisterType($event.value)">
          <mat-option value="FAMILY">{{ 'family' | i18next }}</mat-option>
          <mat-option value="RETIREE">{{ 'retiree' | i18next }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field *ngIf="!isEmail() && !isExternVoOrRetiree()">
        <mat-label for="nis">{{ 'nis' | i18next }}</mat-label>
        <input matInput formControlName="nis" minlength="6" maxlength="6" #autofocus />
      </mat-form-field>
      <mat-form-field *ngIf="!isEmail() && isExternVoOrRetiree()">
        <mat-label for="nis">{{ 'nif' | i18next }}</mat-label>
        <input matInput formControlName="nis" minlength="9" maxlength="9" #autofocus />
      </mat-form-field>
      <!-- end -->
      <mat-form-field *ngIf="isEmail()">
        <mat-label for="nis">{{ 'email' | i18next }}</mat-label>
        <input matInput type="email" formControlName="nis" #autofocus />
      </mat-form-field>
      <span *ngIf="controlInput('nis')" class="error-message">
        {{ 'inputInvalid' | i18next }}
      </span>
      <!-- CRMSP-7485 - Acceso a MyGarage VO para jubilados -->
      <ng-container *ngIf="group === 'RETIREE'">

        <div class="register-row">
          <mat-form-field>
            <mat-label>{{ 'name' | i18next }}</mat-label>
            <input matInput formControlName="name" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'surnames' | i18next }}</mat-label>
            <input matInput formControlName="surname" />
          </mat-form-field>
        </div>

        <div class="register-row">
          <mat-form-field>
            <mat-label>{{ 'email' | i18next }}</mat-label>
            <input matInput type="email" formControlName="email" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'phone' | i18next }}</mat-label>
            <input matInput type="text" formControlName="phone" minlength="9" maxlength="9" />
          </mat-form-field>
        </div>

        <mat-form-field>
          <mat-label>{{ 'birthDate' | i18next }}</mat-label>
          <input matInput type="date" formControlName="birthDate" />
        </mat-form-field>

      </ng-container>
      <!-- end -->
      <mat-form-field>
        <mat-label for="password">{{ 'password' | i18next }}</mat-label>
        <input matInput type="password" formControlName="password" />
      </mat-form-field>
      <mat-form-field>
        <mat-label for="repeatPassword">{{
          'repeatPassword' | i18next
          }}</mat-label>
        <input matInput type="repeatPassword" type="password" formControlName="repeatPassword" />
      </mat-form-field>
      <p [ngClass]="errorMsg('repeatPassword')" class="error-text text">
        {{ 'passwordPattern' | i18next }}
      </p>
      <app-error-with-guide class="error-message" [message]="errorMessage">
      </app-error-with-guide>
      <app-error-with-guide class="error-message" [messageLogin]="loginErrorMessage"
        [showGuideLink]="showDownloadGuideLink">
      </app-error-with-guide>
      <div class="btn-container">
        <button mat-button type="button" class="btn-container--btnCancel" [routerLink]="['/login']">
          {{ 'btnCancel' | i18next | uppercase }}
        </button>
        <button mat-button type="submit" class="btn-container--btn" (click)="onSubmit()"
          [disabled]="!registerForm.valid">
          {{ 'btnAccept' | i18next | uppercase }}
        </button>
        <div class="text-center spinner-container" *ngIf="spinner">
          <div class="spinner-border spinner" role="status"></div>
        </div>
      </div>
    </form>
  </section>
</main>